let profileMenuInitialized = false;

const initializeProfileMenu = () => {
  if (profileMenuInitialized) return;

  const profileButton = document.querySelector('.profile-btn');
  const profileDropdown = document.querySelector('.profile-dropdown');
  const body = document.body;

  if (!profileButton || !profileDropdown || !body) return;

  profileButton.addEventListener('click', (event) => {
    event.stopPropagation();
    profileDropdown.classList.toggle('show');
    body.classList.toggle('lock', profileDropdown.classList.contains('show'));
  });

  document.addEventListener('click', (event) => {
    if (
      !profileDropdown.contains(event.target) &&
      !profileButton.contains(event.target)
    ) {
      profileDropdown.classList.remove('show');
      body.classList.remove('lock');
    }
  });

  profileMenuInitialized = true;
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProfileMenu, { once: true });
} else {
  initializeProfileMenu();
}

export { initializeProfileMenu };
  
